import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Container } from '@design-system/container';
import { Picture } from './Picture';
import { Title } from './Title';
export const PictureOnly = ({ coverPictureUrls, title }) => (_jsxs(StyledContainer, { dataTestId: "appheader-container", children: [_jsx(Title, { customPadding: {
                pb: 4,
                pt: { s: 6, m: 0 },
                px: { s: 4, m: 0 },
            }, title: title }), _jsx(Picture, { coverPictureUrls: coverPictureUrls })] }));
const StyledContainer = styled(Container).attrs(() => ({
    flexDirection: 'column',
    justifyContent: 'start',
    px: {
        l: 8,
        m: 6,
    },
    py: {
        l: 6,
        m: 4,
    },
})) ``;
//# sourceMappingURL=PictureOnly.js.map